module.exports = __webpack_public_path__ + "img/bal-zvuk-logo.e720ce0e.svg";